export const FORM_FIELDS_NAMES = {
    NAME: 'name',
    ADDRESS: 'address',
    CITY: 'city',
    ZIP_CODE: 'zip',
    STATE: 'state',
    COUNTRY: 'country',
    CONTACT_NUMBER: 'contactNumber',
    FAX_NUMBER: 'fax'
}